import { createContext } from 'react';
import { IRestaurantLocalizationGroup, IUpdateRestaurantLocalization } from 'types';

export type TLocalizationSelectedItem = { id: string | null; name: string | null };
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'addWording';
export type TLocalizationSettingsMode = 'view' | 'edit';
export interface IDeleteWordingData {
	groupId: string;
	wordingId: string;
}

export interface ILocalizationState {
	needRefetchWordings: boolean;
	loading: boolean;
	selectedGroup: TLocalizationSelectedItem | null;
	selectedLanguage: TLocalizationSelectedItem | null;
	useCustomerSettings: boolean;
	groups: IRestaurantLocalizationGroup[];
	invalidFields: string[];
	dataForSubmit: IUpdateRestaurantLocalization | null;
	deleteWordingData: IDeleteWordingData | null;
	typeOfModalWindow: TTypeOfModalWindow;
	mode: TLocalizationSettingsMode;
}

export const localizationInitialState: ILocalizationState = {
	needRefetchWordings: false,
	loading: true,
	selectedGroup: null,
	selectedLanguage: null,
	useCustomerSettings: false,
	groups: [],
	invalidFields: [],
	dataForSubmit: null,
	deleteWordingData: null,
	typeOfModalWindow: null,
	mode: 'view',
};

export interface ILocalizationContext extends ILocalizationState {
	refetchWordings(value: boolean | null): void;
	setGroup(value: TLocalizationSelectedItem | null): void;
	setLanguage(value: TLocalizationSelectedItem | null): void;
	removeWording(groupId: string, wordingId: string): void;
	toggleUseCustomerSettings(): void;
	addInvalidField(value: string): void;
	clearInvalidFields(): void;
	setDataForSubmit(data: IUpdateRestaurantLocalization | null): void;
	setDeleteWordingData(value: IDeleteWordingData | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeMode(value: TLocalizationSettingsMode): void;
	updateGroups(value: IRestaurantLocalizationGroup[]): void;
}

export const LocalizationContext = createContext<ILocalizationContext>({
	refetchWordings: () => undefined,
	setGroup: () => undefined,
	setLanguage: () => undefined,
	removeWording: () => undefined,
	toggleUseCustomerSettings: () => undefined,
	addInvalidField: () => undefined,
	clearInvalidFields: () => undefined,
	setDataForSubmit: () => undefined,
	setDeleteWordingData: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeMode: () => undefined,
	updateGroups: () => undefined,
	...localizationInitialState,
});
